import FilterModel from 'app/components/FilterModel';
import PageLoader from 'app/components/PageLoader';
import PaginatedTable from 'app/components/table/PaginationTable';
import { reportvoucherPointsDataHeader } from 'app/constants/table-header-constants';
import useVoucherClaimedDataReport from './useVoucherClaimedDataReport';

const VoucherClaimedDataReport = () => {
  const {
    pageLoading,
    filteredData,
    paginationHandler,
    navigate,
    totalNumber,
    currentPage,
    dataPerPage,
    pageCount,
    sectionObj,
    isFilterOpen,
    setIsFilterOpen,
    values,
    setValues,
    resetfilterModel,
    handleSubmit,
    handleFilterCancel,
    fetchReportData,
    isFiltering,
  } = useVoucherClaimedDataReport();

  return (
    <>
      <div className='cms-content__container'>
        <div className='cms-content__container billmanagement'>
          <PaginatedTable
            fulldata={filteredData}
            sectionObj={sectionObj}
            columns={reportvoucherPointsDataHeader}
            data={filteredData}
            currentPage={currentPage}
            dataPerPage={dataPerPage}
            pageCountNumber={pageCount}
            totalNumber={totalNumber}
            pageLoading={pageLoading}
            navigate={navigate}
            isLoading={pageLoading}
            paginationHandler={paginationHandler}
            fetchData={fetchReportData}
            isFiltering={isFiltering}
            values={values}
          />
        </div>
        {isFilterOpen && (
          <FilterModel
            isFilterOpen={isFilterOpen}
            setIsFilterOpen={setIsFilterOpen}
            onSubmit={handleSubmit}
            onCancel={handleFilterCancel}
            values={values}
            setValues={setValues}
            resetfilter={resetfilterModel}
          >
            <>
              <div className='offcanvas-item'>
                <label>Mall Name:</label>
                <input
                  type='text'
                  value={values?.mallName}
                  onChange={(e) =>
                    setValues({ ...values, mallName: e.target.value })
                  }
                />
              </div>
              <div className='offcanvas-item'>
                <label>Phone:</label>
                <input
                  type='text'
                  value={values?.phone}
                  onChange={(e) =>
                    setValues({ ...values, phone: e.target.value })
                  }
                />
              </div>
              <div className='offcanvas-item'>
                <label>Membership</label>
                <input
                  type='text'
                  value={values?.membershipType}
                  onChange={(e) =>
                    setValues({ ...values, membershipType: e.target.value })
                  }
                />
              </div>
              <label>Voucher Collected Date ranges:</label>
              <div className='offcanvas-item'>
                <label>Start Date</label>
                <input
                  type='date'
                  value={values?.voucherColledtedDateStart}
                  max={values?.voucherColledtedDateEnd}
                  onChange={(e) =>
                    setValues({
                      ...values,
                      voucherColledtedDateStart: e.target.value,
                    })
                  }
                />
              </div>
              <div className='offcanvas-item'>
                <label>End Date</label>
                <input
                  type='date'
                  value={values?.voucherColledtedDateEnd}
                  min={values?.voucherColledtedDateStart}
                  onChange={(e) =>
                    setValues({
                      ...values,
                      voucherColledtedDateEnd: e.target.value,
                    })
                  }
                />
              </div>
            </>
          </FilterModel>
        )}
      </div>
      {pageLoading === true && <PageLoader pageLoading={pageLoading} />}
    </>
  );
};

export default VoucherClaimedDataReport;
